// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../action-list';
import {getApplication} from '../../shared/repositories';

export const readApplication = () =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const claimTypeKey = 'ZZTK';
            const data = await getApplication(claimTypeKey);

            dispatch({
                data,
                type: actions.UPDATE_CLAIM_TRACK_APPLICATION_COLLECTION
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/claim/track/action-creators/get-application.js